import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const FlowDownstreamFlowsFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowDownstreamFlowsFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: FlowSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
